export const formatoFechaHoraTabla = (fecha, hora) => {


    let date = new Date(fecha)
    // const days = ['Dom', 'Lun', 'Mar', 'Mie', 'Jue', 'Vie', 'Sab']
    const months = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic']

    let dia = date.getDate();
    let mes = date.getMonth();
    let year = date.getFullYear() - 2000;
    let fechaHora = new Date(hora)
    let horaFecha = fechaHora.getHours() ? fechaHora.getHours() : 'N';
    let minutos = fechaHora.getMinutes() ? fechaHora.getMinutes() : 'A';

    if (minutos < 10) {
        minutos = '0' + minutos
    }

    // let hora = date.getHours() + ":" + date.getMinutes();

    let texto = dia + " " + months[mes] + " " + year + ' Hrs ' + horaFecha + ':' + minutos

    return texto


}